export default function convertToEscape(txt) {
    return escape(txt);
}